import RelatoriosModulosService from "@/services/RelatoriosModulosService";

export const relatoriosModulos = {
  namespaced: true,
  state: {
    relatoriosModulos: {},
  },
  actions: {
    getRelatoriosModulos({ commit }, payload) {
      return RelatoriosModulosService.GetRelatoriosModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRelatoriosModulos({ commit }, payload) {
      return RelatoriosModulosService.PostRelatoriosModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRelatoriosModulos({ commit }, payload) {
      return RelatoriosModulosService.PutRelatoriosModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRelatoriosModulos({ commit }, payload) {
      return RelatoriosModulosService.DeleteRelatoriosModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRelatoriosModulosOData({ commit }, payload) {
      return RelatoriosModulosService.GetRelatoriosModulosOData(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default relatoriosModulos;
